// extracted by mini-css-extract-plugin
export default {"companyContainer":"VK-z","companyImage":"WK-z","container":"XK-z","heading":"YK-z","darkText":"ZK-z","smallHeading":"_K-z","darkBackground":"aL-z","whiteBackground":"bL-z"};